import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'

type NoResultStateProps = {
  resetFilters: () => void
  query?: string
}

export function NoResult({ resetFilters, query }: NoResultStateProps) {
  const { t } = useTranslation(['table'])

  const message = query?.trim()
    ? t('table:noResultsWithQuery', { query: query.trim() })
    : t('table:noResults')

  return (
    <div
      className="flex w-full flex-col items-start justify-start gap-2 bg-white p-3 desktop:h-[4.25rem] desktop:flex-row desktop:items-center desktop:justify-between desktop:align-middle"
      data-testid="table/no-result-state"
    >
      <p className="text-md font-bold leading-light text-brand-2-900">{message}</p>
      <Button size="md" variant="secondary" iconLeft={<Icon.FilterX />} onPress={resetFilters}>
        {t('table:resetFilters')}
      </Button>
    </div>
  )
}
